import React from "react";

interface RewardIconProps {
  width: number;
  height: number;
}

const RewardIcon: React.FC<RewardIconProps> = ({ width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="reward-icon"
    >
      <path
        d="M18.0709 6.32814H13.5V2.53127C13.5 1.25177 14.888 0 16.1675 0H19.8281V4.57087C19.8281 5.54135 19.0414 6.32814 18.0709 6.32814Z"
        fill="#F7931E"
      />
      <path
        d="M8.94666 6.32814H13.5175V2.53127C13.5175 1.25177 12.1296 0 10.8501 0H7.18945V4.57087C7.18945 5.54135 7.97619 6.32814 8.94666 6.32814Z"
        fill="#FBB03B"
      />
      <path
        d="M8.43759 5.90626L7.3877 5.88995L7.43564 0.632812H8.43754L8.43759 5.90626Z"
        fill="white"
      />
      <path
        d="M23.2031 10.5469H3.79688V26.5781H23.2031V10.5469Z"
        fill="#E9483D"
      />
      <path
        d="M12.2344 6.32812V0.84375H13.0781L13.5 6.32812H12.2344Z"
        fill="#F7931E"
      />
      <path
        d="M9.28124 10.5469H3.79688V26.5781H9.28124V10.5469Z"
        fill="#ED6D64"
      />
      <path
        d="M16.0312 10.5469H10.9688V26.5781H16.0312V10.5469Z"
        fill="#F7931E"
      />
      <path
        d="M24.4687 6.32812H2.53125V10.5469H24.4687V6.32812Z"
        fill="#E9483D"
      />
      <path d="M16.875 6.32812H10.125V10.5469H16.875V6.32812Z" fill="#F7931E" />
      <path
        d="M8.4375 6.32812H2.53125V10.5469H8.4375V6.32812Z"
        fill="#ED6D64"
      />
      <path
        d="M13.9219 6.32812H10.125V10.5469H13.9219V6.32812Z"
        fill="#FBB03B"
      />
      <path
        d="M14.3437 10.9688H10.9688V26.5781H14.3437V10.9688Z"
        fill="#FBB03B"
      />
      <path
        d="M13.0781 19.8281H8.85938V12.6562L10.9688 10.9688L13.0781 12.6562V19.8281Z"
        fill="#F7931E"
      />
      <path
        d="M5.06248 10.5469H3.79688V26.5781H5.06248V10.5469Z"
        fill="white"
      />
      <path
        d="M3.79686 6.32812H2.53125V10.5469H3.79686V6.32812Z"
        fill="white"
      />
      <path
        d="M24.9065 5.88994H19.6119C20.0291 5.43151 20.2859 4.82456 20.2859 4.15731V0H15.6554C14.9662 0 14.3181 0.268619 13.8309 0.7562C13.7055 0.881692 13.5952 1.01815 13.4996 1.16293C13.404 1.01815 13.2937 0.881692 13.1683 0.7562C12.681 0.268619 12.0329 0 11.3437 0H6.71319V4.15736C6.71319 4.82456 6.97002 5.43151 7.38728 5.89H2.09277V10.985H3.37469V27H23.6247V10.985H24.9066L24.9065 5.88994ZM9.29715 19.3899V12.8668L10.9684 11.5298L12.6396 12.8668V19.3899H9.29715ZM13.5159 20.2662V12.4457L11.6901 10.985H15.5927V26.1562H11.4065V20.2662H13.5159ZM10.5628 10.1087V6.76623H16.4364V10.1087H10.5628ZM14.4276 1.35257C14.7555 1.02443 15.1914 0.843774 15.6553 0.843774H19.4421V4.15736C19.4421 5.10343 18.6807 5.87203 17.7388 5.89H13.9215L13.9214 5.79779L13.9234 2.58109C13.9234 2.57194 13.9221 2.56301 13.922 2.55392C13.9288 2.10023 14.1061 1.67427 14.4276 1.35257ZM7.55691 4.15736V0.843774H11.3437C11.8076 0.843774 12.2435 1.02443 12.5714 1.35257C12.893 1.67427 13.0703 2.10023 13.077 2.55392C13.077 2.56301 13.0757 2.57194 13.0757 2.58109L13.0777 5.79779L13.0776 5.89H9.26022C8.31835 5.87203 7.55691 5.10343 7.55691 4.15736ZM2.96906 6.76629H9.68652V10.1088H2.96906V6.76629ZM4.21841 10.985H10.2467L8.42086 12.4457V20.2662H10.5302V26.1562H4.21841V10.985ZM22.7809 26.1562H16.469V10.985H22.7808V26.1562H22.7809ZM24.0302 10.1087H17.3128V6.76623H24.0302L24.0302 10.1087Z"
        fill="#1D1D1B"
      />
      <path
        d="M11.8125 17.7021H10.125V18.5784H11.8125V17.7021Z"
        fill="#1D1D1B"
      />
    </svg>
  );
};

export default RewardIcon;
